<template>
<div>
  <el-button type="primary" size="small" icon="el-icon-back" style="margin-bottom:10px" @click="$router.back(-1)">返回</el-button>
  <div class="box">
    <Cheditor
      ref="cheditor"
      :height="height+'px'"
      width="1000px"
      v-model="content"
      v-if="showCheditor"
      @openDialog="openDialog"
    />
    <div class="console" :style="{ height: height + 75 + 29 + 'px' }">
      <div class="title">模板信息</div>
      <div class="console-body">
        <el-form
          :model="templateData"
          size="small"
          label-position="top"
          :rules="temRules"
          ref="templateForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="文书模板名称" prop="templateName">
            <el-input v-model="templateData.templateName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="文书模板编号" prop="templateNo">
            <el-input v-model="templateData.templateNo"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="公证文书编号" prop="sheetNo">
            <el-input v-model="templateData.sheetNo"></el-input>
          </el-form-item> -->
          <el-form-item label="公证文书类型" prop="sheetNo">
            <el-select  size="small"  v-model="templateData.sheetNo" clearable  placeholder="请选择">
             <el-option  v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="addVar-btn"
              @click="temSubmitForm('templateForm')"
              >立即创建</el-button
            >
          </el-form-item>
        </el-form>
        
        <el-button size="small" class="addVar-btn" @click="addVar"
          >添加变量</el-button
        >
      </div>
    </div>
    <el-dialog
      title="新增变量"
      :visible.sync="showDialog"
      append-to-body
      width="500px"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="变量名称" prop="varName">
          <el-input v-model="ruleForm.varName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
          <el-button @click="showDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</div>
</template>

<script>
import Cheditor from "@/components/cheditor";
export default {
  components: {
    Cheditor,
  },
  data() {
    return {
      content: "",
      height: 650,
      vars: [],
      typeOptions: [
        {
          value: 'gaozhisheet',
          label: "公证告知书",
        },
        {
          value: 'shenqingsheet',
          label: "公证申请表",
        },
        {
          value: 'shoulisheet',
          label: "赋予债权文书强制执行效力公证承诺",
        },
        // {
        //   value: 'gzbilu',
        //   label: "公证询问笔录",
        // },
        {
          value: 'zhuanrangsheet',
          label: "转让通知书",
        }
      ],
      showDialog: false,
      templateData: {
        templateName: "",
        // templateNo: "",
        sheetNo: "",
      },
      ruleForm: {
        varName: "",
      },
      temRules: {
        templateName: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
        ],
        templateNo: [
          { required: true, message: "请输入自定义模板编号，可包含字母、数字、“_”，同一份业务合同下公证文书模板编号不允许重复。", trigger: "blur" },
        ],
        sheetNo: [
          { required: true, message: "请输入公证文书编号", trigger: "blur" },
        ],
      },
      rules: {
        varName: [
          { required: true, message: "请输入变量名称", trigger: "blur" },
        ],
      },
      showCheditor: false
    };
  },
  mounted() {
    this.showCheditor = true;
  },
  beforeDestroy() {
    // this.showCheditor = false;
  },
  destroyed() {
    this.showCheditor = false;
  },
  computed: {},
  methods: {
    openDialog(value) {
      this.showDialog = true;
      this.ruleForm.varName = value;
    },
    addVar() {
      this.showDialog = true;
    },
    save() {
      let reqData = {};
      console.log(this.content);
      console.log(this.vars);
    },
    temSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.$route.query.busiTemplateId, this.templateData, this.content, this.vars);
          let reqData = {
            busiTemplateId: this.$route.query.busiTemplateId,
            ...this.templateData,
            templateInfo: this.content
          };
          console.log(reqData)
          this.$api.addNotaryDocTemplate(reqData).then(res => {
            if (res) {
              this.$message.success('模板添加成功');
              this.$router.replace({
                path: '/templateExamine/docList',
                query: {
                  busiTemplateId: this.$route.query.busiTemplateId,
                  notaryStatus: 2
                }
              })
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let varName = this.ruleForm.varName.replace(/^\s*|\s*$/g, "");
          this.$refs.cheditor.insertHtml(`<span>{{=${varName}}}</span>`);
          // this.$refs.cheditor.addVar(varName);
          this.vars.push({
            paramKey: varName,
          });
          this.showDialog = false;
          this.ruleForm.varName = '';
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../style/mixin";
.box {
  .flex();
  .console {
    width: 250px;
    margin-left: 10px;
    border: 1px solid #d1d1d1;
    flex-shrink: 0;
    .title {
      height: 74px;
      border-bottom: 1px solid #d1d1d1;
      background: #f8f8f8;
      color: #484848;
      font-size: 16px;
      .flex(center);
    }
    .console-body {
      color: #484848;
      font-size: 14px;
      padding: 10px;
      .template-item {
        margin-top: 10px;
        .name {
          margin-bottom: 5px;
        }
      }
      .save-btn,
      .addVar-btn {
        width: 100%;
        margin: 0;
        margin-top: 10px;
      }
    }
  }
}
/deep/ .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}
/deep/ .el-form-item__error{
  background: #fff;
}
</style>